<template>
    <div class="main-body">
        <el-page-header @back="goBack" :content="group_name"></el-page-header>
        <div class="action-bar">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="">
                    <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/add') }}</el-button>
                    <el-button size="small" type="primary" @click="onImport">{{ $strings('word/import') }}</el-button>
                </el-form-item>
                <el-form-item label="" style="margin-left:2em;">
                    <el-button size="small" @click="onSelectAll">{{ $strings('word/select_all') }}</el-button>
                    <el-button size="small" @click="onSelectReverse">{{ $strings('word/select_inverse') }}</el-button>
                    <el-button size="small" @click="clearAll">{{ $strings('word/clear') }}</el-button>
                    <el-button size="small" :disabled="checkList.length === 0" @click="onDrop">
                        {{ $strings('word/delete') }}
                    </el-button>
                </el-form-item>
                <el-form-item label="" style="margin-left:2em;">
                    <el-button size="small" @click="fetchData">{{ $strings('word/refresh') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>
        <h4>{{ $strings('word/numbers') }}</h4>
        <div v-loading="loadingNumbers">
            <el-checkbox-group v-model="checkList">
                <el-row :gutter="10">
                    <el-col :span="3" v-for="(item, idx) in numbers" :key="idx">
                        <el-card shadow="never" :body-style="{padding: '12px'}" style="margin-bottom: 12px;">
                            <el-checkbox :label="item"></el-checkbox>
                        </el-card>
                    </el-col>
                </el-row>
            </el-checkbox-group>
        </div>
        <div>
            <el-dialog
                :title="$strings('word/add')"
                :visible.sync="showAdd"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                @closed="onClose"
                width="30%">
                <div>
                    <el-form ref="form" :model="row" label-width="0">
                        <el-form-item>
                            <el-input type="textarea" v-model="row.numbers_str" rows="5"
                                      :placeholder="$strings('word/numbers')"></el-input>
                        </el-form-item>
                        <p class="tips">Number separate with "," </p>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showAdd = false">{{ $strings('word/cancel') }}</el-button>
                    <el-button type="primary" @click="onSave()" :loading="saving">{{ $strings('word/confirm') }}
                    </el-button>
                </div>
            </el-dialog>
            <el-dialog
                :title="$strings('word/import')"
                :visible.sync="showImport"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                @closed="onClose"
                width="30%">
                <div>
                    <Hint :message="$strings('word/import_async_hint')" class="import-hint"/>
                    <el-link type="primary" :href="demoLink">{{ $strings('word/demo_import_format') }}</el-link>
                    <el-divider></el-divider>
                    <Uploader action="/cpsite/address/items/upload/sign" @uploadSuccess="onUploadSuccess"/>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="onCloseUpload()">{{ $strings('word/close') }}</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {CpSiteAddressItemsCreate, CpSiteAddressItemsRead} from "@/api/cpsite/api";
import {API_STATUS_CODE} from "@/config/config";
import {EVENT_ROUTER_BACK, PubSubGlobal} from "@/utils/pubsub";
import {CpSiteAddressItemsDrop, CpSiteAddressItemsImport} from "../../../../api/cpsite/api";
import Hint from "../../../../components/hint";
import Uploader from "@/components/uploader";
import {STATIC_FILE} from "../../../../config/config";

export default {
    name: "cpsite-address-items",
    components: {Hint, Uploader},
    props: ['group_id', 'group_name'],
    data() {
        return {
            loadingNumbers: true,
            formInline: {},
            numbers: [],
            checkList: [],
            total: 0,
            row: {},
            saving: false,
            showAdd: false,
            showImport: false,
            disableUpload: false,
            demoLink: STATIC_FILE.DEMO_IMPORT_LINK,
            importForm: {file_link: '', group_id: this.group_id, file_name: ''},
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        onUploadSuccess(ret) {
            CpSiteAddressItemsImport({
                file_link: ret.file_link,
                file_name: ret.file_name,
                group_id: this.group_id
            }).then();
        },
        onCloseUpload() {
            this.showImport = false;
        },
        onCreate() {
            this.row.group_id = this.group_id;
            this.showAdd = true;
        },
        onImport() {
            this.row.group_id = this.group_id;
            this.showImport = true;
        },
        onSave() {
            this.saving = true;
            this.row.numbers = this.row.numbers_str.split(',');
            CpSiteAddressItemsCreate(this.row).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.saving = false;
                    this.showAdd = false;
                    this.fetchData();
                }
            });
        },
        onDrop() {
            this.loadingNumbers = true;
            CpSiteAddressItemsDrop({group_id: this.group_id, numbers: this.checkList}).then((resp) => {
                if (resp.data.data.count > 0) {
                    this.$notify.success({
                        title: 'SUCCESS',
                        message: 'delete ' + resp.data.data.count + ' items successfully'
                    })
                    this.checkList = [];
                    this.fetchData();
                }
            }).finally(() => {
                this.loadingNumbers = false;
            });
        },
        onClose() {
            this.row = {};
        },
        goBack() {
            this.$router.push('/cpsite/address');
            PubSubGlobal.publish(EVENT_ROUTER_BACK, "/cpsite/address");
        },
        onSelectAll() {
            this.checkList = this.numbers;
        },
        clearAll() {
            this.checkList = [];
        },
        onSelectReverse() {
            let diff = [];
            this.numbers.forEach((item) => {
                if (this.checkList.indexOf(item) < 0) {
                    diff.push(item);
                }
            });
            this.checkList = diff;
        },
        fetchData() {
            this.loadingNumbers = true;
            CpSiteAddressItemsRead({group_id: this.group_id}).then((resp) => {
                this.numbers = [];
                this.total = resp.data.data.count;
                if (resp.data.data.count > 0) {
                    resp.data.data.rows.forEach((item) => {
                        this.numbers.push(item.number);
                    })
                }
                this.loadingNumbers = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    margin-top: 1em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.tips {
    font-size: 12px;
    color: #1A1A1A;
    text-align: right;
    margin: 0;
}

.import-hint {
    margin-bottom: 1em;
}
</style>